import { applyInlineStyles } from '../../utils/dom-style'
import { type EmbedCSSStyles } from '../style'
import { resolveValue } from '../../utils/transform'

/**
 * Switches style set of an element.
 */
export class ElementStyleSetSwitcher {
  el: HTMLElement
  styleSetsMap = new Map<string, EmbedCSSStyles | (() => EmbedCSSStyles)>()
  currentSet: string | undefined

  constructor (el: HTMLElement) {
    this.el = el
  }

  addStyleSet (key: string, style: EmbedCSSStyles | (() => EmbedCSSStyles)) {
    this.styleSetsMap.set(key, style)
  }

  /**
   * Consider: optimize this by caching the last applied style?
   * @param key
   * @returns
   */
  applyStyleSet (key: string) {
    const value = this.styleSetsMap.get(key)
    const styles = resolveValue(value)
    applyInlineStyles(styles ?? {}, this.el)
    this.currentSet = key
  }

  applyStyles (style: EmbedCSSStyles | (() => EmbedCSSStyles)) {
    applyInlineStyles(resolveValue(style) ?? {}, this.el)
  }
}
